<script>
import ProjectService from "@/services/ProjectService";
import MunicipalityService from "@/services/MunicipalityService";
import UserService from "@/services/UserService";
import VFilters from "@/components/Search/VFilters";
import AppCfg from "@/mixins/AppCfg";
import VPortfolioStage from "./components/VPortfolioStage";
import { mapGetters } from "vuex";
import dayjs from "dayjs";

export default {
    mixins: [AppCfg],
    components: { VFilters, VPortfolioStage },
    data() {
        return {
            loading: true,
            projects: [],
            meta: {},
            apiFilterView: "",
            municipalities: [],
            users: []
        };
    },
    computed: {
        optTypes() {
            let d = this.appCfg.Projects.project_type;
            return { ...{ "": this.$t("planning.all_types") }, ...d };
        },
        optStatuses() {
            let d = this.appCfg.Projects.status;
            return { ...{ "": this.$t("planning.all_statuses") }, ...d };
        },
        ...mapGetters("auth", ["getMyId"])
    },
    async created() {
        await this.fetchMunicipalities();
        await this.fetchUsers();
        this.initSearch();
        await this.fetchData();
        this.loading = false;
        this.$apiEnableWatcher();
    },
    methods: {
        handleSort(field) {
            if (
                "sort" in this.apiPaginator &&
                field == this.apiPaginator["sort"]
            ) {
                this.apiPaginator["direction"] =
                    this.apiPaginator["direction"] == "asc" ? "desc" : "asc";
            } else {
                this.apiPaginator = { sort: field, direction: "asc" };
            }

            this.fetchData();
        },
        async fetchData() {
            try {
                let params = this.$buildParams();
                const { data } = await ProjectService.GET_planningPortfolio(
                    params
                );
                this.projects = data.data;
                this.meta = data.meta;
            } catch (e) {
                console.log("fd de", e);
            }
        },
        async fetchMunicipalities() {
            try {
                const { data } = await MunicipalityService.GET_dropdown({
                    preset: "pm"
                });
                this.municipalities = data.data;
                this.municipalities.unshift({
                    value: "",
                    label: this.$t("planning.all_municipalities")
                });
            } catch (e) {
                console.log("f mun e", e);
            }
        },
        async fetchUsers() {
            try {
                const r = await UserService.dropdown({ preset: "pm" });
                this.users = r.data.data;
                this.users.unshift({
                    value: "",
                    label: this.$t("planning.all_users")
                });
            } catch (e) {
                console.log("fetchUsers exception", e);
            }
        },
        initSearch() {
            // Check if the PM is in the list
            const filter_pm = this.users.find(entry => {
                if (parseInt(entry.value) === parseInt(this.getMyId)) {
                    return true;
                }
            });

            this.apiSearchFilter = {
                responsible_user_id:
                    typeof filter_pm === "undefined" ? "" : filter_pm.value,
                municipality_id: "",
                project_type: "",
                status: "5",
                search: ""
            };

            this.apiPaginator = {
                sort: "Projects.title",
                direction: "asc"
            };
        },
        downloadPDF() {
            const params = this.$buildParams();
            params.pdf = 1;

            const queryString = new URLSearchParams(params).toString();
            const url = `/v1/projects/planning-portfolio?${queryString}`;

            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error("Failed to fetch PDF");
                    }
                    return response.blob();
                })
                .then(blob => {
                    const link = document.createElement("a");
                    const now = dayjs().format("DD-MM-YYYY");
                    link.href = URL.createObjectURL(blob);
                    link.download = `portfolio-${now}.pdf`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                })
                .catch(error => console.error(error));
        },
        downloadCSV() {
            const params = this.$buildParams();
            params.csv = 1;

            const queryString = new URLSearchParams(params).toString();
            const url = `/v1/projects/planning-portfolio?${queryString}`;

            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error("Failed to fetch CSV");
                    }
                    return response.blob();
                })
                .then(blob => {
                    const link = document.createElement("a");
                    const now = dayjs().format("DD-MM-YYYY");
                    link.href = URL.createObjectURL(blob);
                    link.download = `portfolio-${now}.csv`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                })
                .catch(error => console.error(error));
        },
        downloadPCSV() {
            const params = this.$buildParams();
            params.pcsv = 1;

            const queryString = new URLSearchParams(params).toString();
            const url = `/v1/projects/planning-portfolio?${queryString}`;

            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error("Failed to fetch CSV");
                    }
                    return response.blob();
                })
                .then(blob => {
                    const link = document.createElement("a");
                    const now = dayjs().format("DD-MM-YYYY");
                    link.href = URL.createObjectURL(blob);
                    link.download = `portfolio-${now}.xlsx`;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(link.href);
                })
                .catch(error => console.error(error));
        }
    }
};
</script>

<template>
    <div class="v-planning-portfolio">
        <base-header class="pb-1" type="">
            <bread-bag></bread-bag>
        </base-header>
        <div class="container-fluid">
            <div class="row card-wrapper">
                <div class="col-12">
                    <v-filters
                        :enable-filters="true"
                        v-model="apiSearchFilter.search"
                        :search="true"
                        start-open
                        :search-placeholder="
                            $t('projects.placeholder_search_in_projects')
                        "
                        @reset-search="initSearch"
                    >
                        <template slot="default">
                            <div class="col">
                                <FormulateInput
                                    v-model="apiSearchFilter.project_type"
                                    :placeholder="
                                        $t(
                                            'form_elems.portfolio.placeholder_all_types'
                                        )
                                    "
                                    type="multiselect"
                                    :multiple="false"
                                    :options="optTypes"
                                />
                            </div>
                            <div class="col">
                                <FormulateInput
                                    v-model="apiSearchFilter.status"
                                    :placeholder="
                                        $t(
                                            'form_elems.portfolio.placeholder_all_statuses'
                                        )
                                    "
                                    type="multiselect"
                                    :multiple="false"
                                    :options="optStatuses"
                                />
                            </div>
                            <div class="col">
                                <FormulateInput
                                    v-model="
                                        apiSearchFilter.responsible_user_id
                                    "
                                    :placeholder="
                                        $t(
                                            'form_elems.portfolio.placeholder_all_pms'
                                        )
                                    "
                                    type="multiselect"
                                    :multiple="false"
                                    :options="users"
                                />
                            </div>
                            <div class="col">
                                <FormulateInput
                                    v-model="apiSearchFilter.municipality_id"
                                    :placeholder="
                                        $t(
                                            'form_elems.portfolio.placeholder_all_municipalitites'
                                        )
                                    "
                                    type="multiselect"
                                    :multiple="false"
                                    :options="municipalities"
                                />
                            </div>
                            <div class="col">
                                <div class="d-flex align-items-center">
                                    <base-button
                                        @click="downloadCSV"
                                        type="primary"
                                        outline
                                        class="m-0"
                                        block
                                        ><i class="far fa-file-csv"></i>
                                        {{
                                            $t("project.short_export_csv")
                                        }}</base-button
                                    >
                                    <base-button
                                        @click="downloadPCSV"
                                        type="primary"
                                        class="m-0 ml-1"
                                        outline
                                        block
                                        ><i class="far fa-file-excel"></i>
                                        {{
                                            $t("project.short_export_xls")
                                        }}</base-button
                                    >
                                    <base-button
                                        @click="downloadPDF"
                                        class="m-0 ml-1"
                                        type="primary"
                                        outline
                                        block
                                        ><i class="far fa-file-pdf"></i>
                                        {{
                                            $t("project.short_export_pdf")
                                        }}</base-button
                                    >
                                </div>
                            </div>
                        </template>
                    </v-filters>
                </div>

                <div class="col-12">
                    <card body-classes="px-0">
                        <div
                            class="px-4 text-right mb-2"
                            style="font-size: 12px;"
                        >
                            <i class="fas fa-fw fa-flag text-danger"></i> -
                            {{ $t("project.warn_flag_red_explanation") }} |
                            <i class="fas fa-fw fa-flag text-warning"></i> -
                            {{ $t("project.warn_flag_yellow_explanation") }}
                        </div>
                        <v-loader v-if="loading" :loading="loading" />
                        <template v-else-if="Object.keys(projects).length > 0">
                            <div
                                class="v-portfolio-stage-container"
                                v-for="stage in meta.stages"
                                :key="stage.stage_id"
                            >
                                <h1 class="mx-4">
                                    {{ stage.name }}
                                </h1>

                                <v-portfolio-stage
                                    :projects="projects[stage.stage_id]"
                                    :paginator="apiPaginator"
                                    @sort="handleSort"
                                />
                            </div>
                        </template>

                        <div class="px-4" v-else>
                            <div class="alert alert-warning">
                                {{ $t("project.no_projects_found") }}
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
.v-portfolio-stage-container {
    margin-bottom: 50px;
}
</style>
